import { useMemo } from "react";

import { DimensionValue } from "@/lib/dimensions";
import { ParameterTimeSeriesChartResult } from "@/lib/api";
import { TimeSeriesConfig } from "@/components/graph/graph.types";
import Graph from "@/components/graph/graph";
import Stack from "@/components/stack/stack";
import { getSharedChartTimeBounds } from "@/components/graph/get-shared-chart-time-bounds";
import { useSelectedTimeRange } from "@/features/dashboard/store";

interface TimeseriesGraphsProps {
  timeSeriesConfigs: TimeSeriesConfig[];
  data: ParameterTimeSeriesChartResult[];
  currentTime: DimensionValue;
}

const TimeseriesGraphs = ({
  timeSeriesConfigs,
  data,
  currentTime,
}: TimeseriesGraphsProps) => {
  const timeRange = useSelectedTimeRange();

  // Shared, data-cropped x-axis so every chart stays aligned on the same timeline.
  const timeBounds = useMemo(
    () => getSharedChartTimeBounds(data, timeRange),
    [data, timeRange],
  );

  return (
    <Stack flexDirection="column" gap={8}>
      {timeSeriesConfigs.map((config, i) => (
        <Graph
          key={i} // TODO: maybe improve this? add IDs to time series configs?
          config={config}
          data={data}
          currentTime={currentTime}
          timeBounds={timeBounds}
        />
      ))}
    </Stack>
  );
};

export default TimeseriesGraphs;
